import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import createIndexedDBStorage from "redux-persist-indexeddb-storage";
import loginDetailsSlice from "./loginDetailsSlice";
import subjectSlice from "@src/app/subjectSlice";
import projectSlice from "@src/app/projectSlice";
import { LoginApiSlice } from "@src/api/LoginApiSlice";
import { SubjectApiSlice } from "@src/api/SubjectApiSlice";
import { UserApiSlice } from "@src/api/UserApiSlice";
import { ChapterApiSlice } from "@src/api/ChapterApiSlice";
import { ModuleApiSlice } from "@src/api/ModuleApiSlice";
import { TopicApiSlice } from "@src/api/TopicApiSlice";
import { SubTopicApiSlice } from "@src/api/SubTopicApiSlice";
import { SyllabusApiSlice } from "@src/api/SyllabusApiSlice";
import { QuestionApiSlice } from "@src/api/QuestionApiSlice";
import { AssessmentApiSlice } from "@src/api/QuizApiSlice";
import { PracticeQuestionApiSlice } from "@src/api/PracticeQuestionApiSlice";
import { StudentQuizApiSlice } from "@src/api/StudentQuizApiSlice";
import studentQuizReducer from "./studentQuizSlice";
import studentTournamentSlice from "./studentTournamentSlice";
import tcsNqtTimerReducer from "./tcsNqtTimerSlice";
import studentChallengeAssessmentSlice from "./StudentChallengeAssessment";
import trainerTaskRoomSlice from "./trainerTaskRoomSlice";
import webSocketSlice from "./webSocketSlice";
import { TreeApiSlice } from "@src/api/TreeApiSlice";
import { StudentProfileApiSlice } from "@src/api/StudentProfileApiSlice";
import { BatchApiSlice } from "@src/api/BatchApiSlice";
import globalSlice from "@src/app/globalSlice";
import authSlice from "@src/app/authSlice";
import parentSelectTreeSlice from "@src/app/parentSelectTreeSlice";
import elpSelectTreeSlice from "@src/app/elpSelectTreeSlice";
import currentQuizReducer from "./currentQuizSlice";
import headerReducer from "./headersSlice";
import elpQuestionSlice from "./elpQuestionSlice";
import { ElpAnswerSubmissionApiSlice } from "@src/api/ElpAnswerSubmissionApiSlice";
import testCaseSlice from "@src/app/testCasesSlice";
import trainerTestCasesSlice from "@src/app/trainerTestCasesSlice";
import assignmentQuestionReducer from "./assignmentQuestionSlice";
import { RunApiSlice } from "@src/api/RunApiSlice";
import { BranchApiSlice } from "@src/api/BranchApiSlice";
import { ResultApiSlice } from "@src/api/ResultApiSlice";
import {
  ChallengeCommonApiSlice,
  CommonApiSlice,
} from "@src/api/CommonApiSlice";
import { websocketApiSlice } from "@src/api/websocketApiSlice";
import { GeneralCodeRun } from "@src/api/GeneralCodeRun";
import { OrganizationApiSlice } from "@src/api/OrganizationApiSlice";
import { SubOrganizationApiSlice } from "@src/api/SubOrganizationApiSlice";
import { ClientsApiSlice } from "@src/api/ClientApiSlice";
import { AttendanceApiSlice } from "@src/api/AttendanceApiSlice";
import { TPAttendanceApiSlice } from "@src/api/TPAttendanceApiSlice";
import { TaskManagerQuizApiSlice } from "@src/api/TaskManagerQuizApiSlice";
import { QuizGroupApiSlice } from "@src/api/QuizGroupApiSlice";
import { TournamentsApiSlice } from "@src/api/TournamentsApiSlice";
import { CategoryApiSlice } from "@src/api/CategoryApiSlice";
import { CategoryTopicApiSlice } from "@src/api/CategoryTopicApiSlice";
import { CategoryQuestionsApiSlice } from "@src/api/CategoryQuestionsApiSlice";
import { CategoryCompanyApiSlice } from "@src/api/CategoryCompanyApiSlice";
import { CategoryListApiSlice } from "@src/api/CategoryListApiSlice";
import { ChallengeApiSlice } from "@src/api/ChallengeApiSlice";
import { DashboardApiSlice } from "@src/api/DashboardApiSlice";
import { RegistrationTemplateApiSlice } from "@src/api/RegistrationTemplateApiSlice";
import assesmentSidebar from "@src/app/AssessmentSidebarSlice";
import classroomSidebar from "@src/app/classroomSidebarSlice";
import practiceQSidebar from "@src/app/practiceQuesSidebarSlice";
import courseSidebar from "@src/app/courseSidebarSlice";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { TraitsApiSlice } from "@src/api/TraitsApiSlice";
import { ParagraphApiSlice } from "@src/api/ParagraphApiSlice";
import { PromptApiSlice } from "@src/api/PromptApiSlice";
import attendanceSlice from "./AttendanceSlice";
import { ClientDashboardApi } from "@src/api/ClientDashboardApiSlice";
import { AiApiSlice } from "@src/api/AiApiSlice";
import { VideoConfigApiSlice } from "@src/api/VideoConfigApiSlice";
import { InterviewQuestionsApiSlice } from "@src/api/IntreviewQuestionsApiSlice";
import videoProgressSlice from "./videoProgressSlice";
import videoDownloadSlice from "./videoDownloadSlice";
import { InterviewApiSlice } from "@src/api/InterviewApiSlice";
import addQuestionDraftSlice from "./addQuestionDraftSlice";
import { ProjectGeneratorApiSlice } from "@src/api/ProjectGeneratorApiSlice";
import projectGeneratorSlice from "./ProjectGeneratorSlice";
import projectExecutionReducer from "./projectExecutionSlice";
import { SubjectDownloadApiSlice } from "@src/api/SubjectDownloadApiSlice";
import { WordzAppApiSlice } from "@src/api/WordzAppApiSlice";
import wordzappReducer from "./wordzappSlice";
import { InteractiveSqlApiSlice } from "@src/api/InteractiveSqlApiSlice";
import { InteractiveMongoApiSlice } from "@src/api/InteractiveMongoApiSlice";
import { StudentFeedbackApiSlice } from "@src/api/StudentFeedbackApiSlice";


const storage = createIndexedDBStorage("my-redux-db");

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "loginDetails",
    "subject",
    "project",
    "studentQuiz",
    "trainerTaskRoom",
    "webSocket",
    "globalSlice",
    "authSlice",
    "currentQuiz",
    "selectTree",
    "elpQuestion",
    "assignmentQuestion",
    "headersData",
    "testCaseSlice",
    "studentTournamentScreen",
    "currentQuizReducer",
    "studentChallengeAssessmentScreen",
    "trainerTestCaseSlice",
    "elpSelectTree",
    "assesmentSidebarSlice",
    "classroomSidebarSlice",
    "practiceQSidebarSlice",
    "courseSidebarSlice",
    "attendanceSlice",
    "videoProgressSlice",
    "addQuestionDraft",
    "projectExecution",
    "tcsNqtTimer",
    "wordzapp",
  ],
  blacklist: [
    LoginApiSlice.reducerPath,
    SubjectApiSlice.reducerPath,
    UserApiSlice.reducerPath,
    ChapterApiSlice.reducerPath,
    ModuleApiSlice.reducerPath,
    TopicApiSlice.reducerPath,
    SubTopicApiSlice.reducerPath,
    SyllabusApiSlice.reducerPath,
    QuestionApiSlice.reducerPath,
    AssessmentApiSlice.reducerPath,
    PracticeQuestionApiSlice.reducerPath,
    StudentQuizApiSlice.reducerPath,
    BatchApiSlice.reducerPath,
    TreeApiSlice.reducerPath,
    StudentProfileApiSlice.reducerPath,
    RunApiSlice.reducerPath,
    BranchApiSlice.reducerPath,
    ResultApiSlice.reducerPath,
    CommonApiSlice.reducerPath,
    websocketApiSlice.reducerPath,
    GeneralCodeRun.reducerPath,
    OrganizationApiSlice.reducerPath,
    SubOrganizationApiSlice.reducerPath,
    ClientsApiSlice.reducerPath,
    AttendanceApiSlice.reducerPath,
    TPAttendanceApiSlice.reducerPath,
    TaskManagerQuizApiSlice.reducerPath,
    QuizGroupApiSlice.reducerPath,
    TournamentsApiSlice.reducerPath,
    CategoryApiSlice.reducerPath,
    CategoryTopicApiSlice.reducerPath,
    CategoryQuestionsApiSlice.reducerPath,
    CategoryCompanyApiSlice.reducerPath,
    CategoryListApiSlice.reducerPath,
    ChallengeApiSlice.reducerPath,
    ChallengeCommonApiSlice.reducerPath,
    DashboardApiSlice.reducerPath,
    RegistrationTemplateApiSlice.reducerPath,
    TraitsApiSlice.reducerPath,
    ParagraphApiSlice.reducerPath,
    ClientDashboardApi.reducerPath,
    AiApiSlice.reducerPath,
    VideoConfigApiSlice.reducerPath,
    InterviewQuestionsApiSlice.reducerPath,
    InterviewApiSlice.reducerPath,
    ProjectGeneratorApiSlice.reducerPath,
    InteractiveSqlApiSlice.reducerPath,
    InteractiveMongoApiSlice.reducerPath,
    StudentFeedbackApiSlice.reducerPath,
  ],
  transforms: [
    encryptTransform({
      secretKey:
        import.meta.env.VITE_TEST_REDUX_SECRET_KEY || "default-secret-key",
      onError: (err) => console.error("Encryption Error:", err),
    }),
  ],
};

const appReducer = combineReducers({
  loginDetails: loginDetailsSlice,
  subject: subjectSlice,
  project: projectSlice,
  studentQuiz: studentQuizReducer,
  studentTournamentScreen: studentTournamentSlice,
  studentChallengeAssessmentScreen: studentChallengeAssessmentSlice,
  trainerTaskRoom: trainerTaskRoomSlice,
  webSocket: webSocketSlice,
  globalSlice: globalSlice,
  authSlice: authSlice,
  currentQuiz: currentQuizReducer,
  selectTree: parentSelectTreeSlice,
  elpSelectTree: elpSelectTreeSlice,
  elpQuestion: elpQuestionSlice,
  assignmentQuestion: assignmentQuestionReducer,
  headersData: headerReducer,
  testCaseSlice: testCaseSlice,
  trainerTestCasesSlice: trainerTestCasesSlice,
  assesmentSidebarSlice: assesmentSidebar,
  classroomSidebarSlice: classroomSidebar,
  practiceQSidebarSlice: practiceQSidebar,
  courseSidebarSlice: courseSidebar,
  attendanceSlice: attendanceSlice,
  videoProgressSlice: videoProgressSlice,
  videoDownload: videoDownloadSlice,
  addQuestionDraft: addQuestionDraftSlice,
  projectExecution: projectExecutionReducer,
  tcsNqtTimer: tcsNqtTimerReducer,
  wordzapp: wordzappReducer,
  [LoginApiSlice.reducerPath]: LoginApiSlice.reducer,
  [SubjectApiSlice.reducerPath]: SubjectApiSlice.reducer,
  [UserApiSlice.reducerPath]: UserApiSlice.reducer,
  [ChapterApiSlice.reducerPath]: ChapterApiSlice.reducer,
  [ModuleApiSlice.reducerPath]: ModuleApiSlice.reducer,
  [ElpAnswerSubmissionApiSlice.reducerPath]:
    ElpAnswerSubmissionApiSlice.reducer,
  [TopicApiSlice.reducerPath]: TopicApiSlice.reducer,
  [SubTopicApiSlice.reducerPath]: SubTopicApiSlice.reducer,
  [SyllabusApiSlice.reducerPath]: SyllabusApiSlice.reducer,
  [QuestionApiSlice.reducerPath]: QuestionApiSlice.reducer,
  [AssessmentApiSlice.reducerPath]: AssessmentApiSlice.reducer,
  [PracticeQuestionApiSlice.reducerPath]: PracticeQuestionApiSlice.reducer,
  [StudentQuizApiSlice.reducerPath]: StudentQuizApiSlice.reducer,
  [BatchApiSlice.reducerPath]: BatchApiSlice.reducer,
  [TreeApiSlice.reducerPath]: TreeApiSlice.reducer,
  [StudentProfileApiSlice.reducerPath]: StudentProfileApiSlice.reducer,
  [RunApiSlice.reducerPath]: RunApiSlice.reducer,
  [BranchApiSlice.reducerPath]: BranchApiSlice.reducer,
  [ResultApiSlice.reducerPath]: ResultApiSlice.reducer,
  [CommonApiSlice.reducerPath]: CommonApiSlice.reducer,
  [OrganizationApiSlice.reducerPath]: OrganizationApiSlice.reducer,
  [SubOrganizationApiSlice.reducerPath]: SubOrganizationApiSlice.reducer,
  [ClientsApiSlice.reducerPath]: ClientsApiSlice.reducer,
  [AttendanceApiSlice.reducerPath]: AttendanceApiSlice.reducer,
  [TPAttendanceApiSlice.reducerPath]: TPAttendanceApiSlice.reducer,
  [websocketApiSlice.reducerPath]: websocketApiSlice.reducer,
  [GeneralCodeRun.reducerPath]: GeneralCodeRun.reducer,
  [TaskManagerQuizApiSlice.reducerPath]: TaskManagerQuizApiSlice.reducer,
  [QuizGroupApiSlice.reducerPath]: QuizGroupApiSlice.reducer,
  [TournamentsApiSlice.reducerPath]: TournamentsApiSlice.reducer,
  [CategoryApiSlice.reducerPath]: CategoryApiSlice.reducer,
  [CategoryTopicApiSlice.reducerPath]: CategoryTopicApiSlice.reducer,
  [CategoryQuestionsApiSlice.reducerPath]: CategoryQuestionsApiSlice.reducer,
  [CategoryCompanyApiSlice.reducerPath]: CategoryCompanyApiSlice.reducer,
  [CategoryListApiSlice.reducerPath]: CategoryListApiSlice.reducer,
  [ChallengeApiSlice.reducerPath]: ChallengeApiSlice.reducer,
  [ChallengeCommonApiSlice.reducerPath]: ChallengeCommonApiSlice.reducer,
  [DashboardApiSlice.reducerPath]: DashboardApiSlice.reducer,
  [RegistrationTemplateApiSlice.reducerPath]:
    RegistrationTemplateApiSlice.reducer,
  [TraitsApiSlice.reducerPath]: TraitsApiSlice.reducer,
  [ParagraphApiSlice.reducerPath]: ParagraphApiSlice.reducer,
  [ClientDashboardApi.reducerPath]: ClientDashboardApi.reducer,
  [AiApiSlice.reducerPath]: AiApiSlice.reducer,
  [VideoConfigApiSlice.reducerPath]: VideoConfigApiSlice.reducer,
  [InterviewQuestionsApiSlice.reducerPath]: InterviewQuestionsApiSlice.reducer,
  [InterviewApiSlice.reducerPath]: InterviewApiSlice.reducer,
  [ProjectGeneratorApiSlice.reducerPath]: ProjectGeneratorApiSlice.reducer,
  [SubjectDownloadApiSlice.reducerPath]: SubjectDownloadApiSlice.reducer,
  [WordzAppApiSlice.reducerPath]: WordzAppApiSlice.reducer,
  [InteractiveSqlApiSlice.reducerPath]: InteractiveSqlApiSlice.reducer,
  [InteractiveMongoApiSlice.reducerPath]: InteractiveMongoApiSlice.reducer,
  [PromptApiSlice.reducerPath]: PromptApiSlice.reducer,
  [StudentFeedbackApiSlice.reducerPath]: StudentFeedbackApiSlice.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/clearTokens") {
    storage.removeItem("persist:root");
    localStorage.removeItem("persist:root");
    state = undefined;
  }
  if (action.type === "RESET_STATE") {
    state = undefined;
    storage.removeItem("persist:root");
    localStorage.removeItem("persist:root");
  }

  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(LoginApiSlice.middleware)
      .concat(SubjectApiSlice.middleware)
      .concat(UserApiSlice.middleware)
      .concat(ChapterApiSlice.middleware)
      .concat(ModuleApiSlice.middleware)
      .concat(ElpAnswerSubmissionApiSlice.middleware)
      .concat(TopicApiSlice.middleware)
      .concat(SubTopicApiSlice.middleware)
      .concat(SyllabusApiSlice.middleware)
      .concat(QuestionApiSlice.middleware)
      .concat(AssessmentApiSlice.middleware)
      .concat(PracticeQuestionApiSlice.middleware)
      .concat(StudentQuizApiSlice.middleware)
      .concat(BatchApiSlice.middleware)
      .concat(StudentProfileApiSlice.middleware)
      .concat(TreeApiSlice.middleware)
      .concat(RunApiSlice.middleware)
      .concat(BranchApiSlice.middleware)
      .concat(ResultApiSlice.middleware)
      .concat(CommonApiSlice.middleware)
      .concat(websocketApiSlice.middleware)
      .concat(GeneralCodeRun.middleware)
      .concat(OrganizationApiSlice.middleware)
      .concat(SubOrganizationApiSlice.middleware)
      .concat(ClientsApiSlice.middleware)
      .concat(AttendanceApiSlice.middleware)
      .concat(TPAttendanceApiSlice.middleware)
      .concat(TaskManagerQuizApiSlice.middleware)
      .concat(QuizGroupApiSlice.middleware)
      .concat(TournamentsApiSlice.middleware)
      .concat(CategoryApiSlice.middleware)
      .concat(CategoryTopicApiSlice.middleware)
      .concat(CategoryQuestionsApiSlice.middleware)
      .concat(CategoryCompanyApiSlice.middleware)
      .concat(CategoryListApiSlice.middleware)
      .concat(ChallengeApiSlice.middleware)
      .concat(ChallengeCommonApiSlice.middleware)
      .concat(DashboardApiSlice.middleware)
      .concat(RegistrationTemplateApiSlice.middleware)
      .concat(TraitsApiSlice.middleware)
      .concat(ParagraphApiSlice.middleware)
      .concat(ClientDashboardApi.middleware)
      .concat(AiApiSlice.middleware)
      .concat(VideoConfigApiSlice.middleware)
      .concat(InterviewQuestionsApiSlice.middleware)
      .concat(InterviewApiSlice.middleware)
      .concat(ProjectGeneratorApiSlice.middleware)
      .concat(SubjectDownloadApiSlice.middleware)
      .concat(WordzAppApiSlice.middleware)
      .concat(InteractiveSqlApiSlice.middleware)
      .concat(InteractiveMongoApiSlice.middleware)
      .concat(StudentFeedbackApiSlice.middleware)
      .concat(PromptApiSlice.middleware),
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;